"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M18 8h-7l-2 5H6l-4 9h20zM7.3 15h3.05l.5-1.26 1.5-3.74h4.14l2.86 10H5.08zM13 1h2v4h-2zm3.1214 4.4682 2.8284-2.8284L20.364 4.054l-2.8284 2.8284zM7.6398 4.0503 9.054 2.636l2.8284 2.8284-1.4142 1.4142z"
}), 'VolcanoOutlined');